<mat-dialog-content>
  <div>Are you sure you want to proceed? The price of one or more of the items is $0.</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="mm-bg-pink mm-text-white mm-mr-2" (click)="onNoClick()">No</button>
  <button mat-flat-button class="mm-bg-green mm-text-white mm-mt-10" (click)="onYesClick()">Yes</button>
</mat-dialog-actions>